import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import CourseBBA from '../CourseBBA'

export default function LayoutCourseBBA() {
    return (
        <div>
            <Header />
            <CourseBBA />
            <Footer />
        </div>
    )
}
